"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INCLUDE_CARD_COMMENT_LABEL = exports.EDIT_CARD_COMMENT_LABEL = exports.CardCommentSubcards = exports.CARD_COMMENT_LEFT_OUT_LABEL = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lucideReact = require("lucide-react");
var _utils = require("@design/lib/utils");
var _AnalyticsContext = require("../../../context/AnalyticsContext");
var _ChatContext = require("../../../context/ChatContext");
var _ProposalEditsContext = require("../../../context/ProposalEditsContext");
var _useProposalEngineEnabled = require("../../../hooks/use-proposal-engine-enabled");
var _useResetProposalEdit = require("../../../hooks/use-reset-proposal-edit");
var _CommentTextEditor = require("../proposal-edit/CommentTextEditor");
var _cardCommentSelections = require("./card-comment-selections");
var _cardKinds = require("./card-kinds");
var _CommentAnchorContext = require("./CommentAnchorContext");
var _ProposalCardActions = require("./ProposalCardActions");
var _RemedyRelocatedIndicator = require("./RemedyRelocatedIndicator");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["comments"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var EDIT_CARD_COMMENT_LABEL = exports.EDIT_CARD_COMMENT_LABEL = "Edit this comment";
var CARD_COMMENT_LEFT_OUT_LABEL = exports.CARD_COMMENT_LEFT_OUT_LABEL = "Left out";
var INCLUDE_CARD_COMMENT_LABEL = exports.INCLUDE_CARD_COMMENT_LABEL = "Include this comment when the card is applied";
var iconButtonClass = "flex flex-shrink-0 cursor-pointer items-center border-none bg-transparent p-0.5";
var CardCommentCheckbox = function CardCommentCheckbox(_ref) {
  var isIncluded = _ref.isIncluded,
    onToggle = _ref.onToggle;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
    type: "button",
    role: "checkbox",
    "aria-checked": isIncluded,
    "aria-label": INCLUDE_CARD_COMMENT_LABEL,
    title: INCLUDE_CARD_COMMENT_LABEL,
    onClick: function onClick(event) {
      event.stopPropagation();
      onToggle();
    },
    className: (0, _utils.cn)("flex h-3.5 w-3.5 flex-shrink-0 cursor-pointer items-center justify-center rounded-[3px] border-[1.5px] p-0", isIncluded ? "border-primary bg-primary" : "border-[#8A8886] bg-white hover:border-primary"),
    "data-sentry-component": "CardCommentCheckbox",
    "data-sentry-source-file": "CardCommentSubcards.tsx",
    children: isIncluded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.Check, {
      size: 10,
      strokeWidth: 3.5,
      className: "text-white"
    }) : null
  });
};
function commentedParagraphTextOf(comment, textRedline) {
  var _ref2, _textRedline$paragrap, _textRedline$paragrap2, _textRedline$insertio;
  return (_ref2 = (_textRedline$paragrap = textRedline === null || textRedline === void 0 || (_textRedline$paragrap2 = textRedline.paragraphs.find(function (cardParagraph) {
    return cardParagraph.bookmark === comment.bookmark;
  })) === null || _textRedline$paragrap2 === void 0 ? void 0 : _textRedline$paragrap2.textProposed) !== null && _textRedline$paragrap !== void 0 ? _textRedline$paragrap : textRedline === null || textRedline === void 0 || (_textRedline$insertio = textRedline.insertions.find(function (insertion) {
    return insertion.bookmark === comment.bookmark;
  })) === null || _textRedline$insertio === void 0 ? void 0 : _textRedline$insertio.textProposed) !== null && _ref2 !== void 0 ? _ref2 : null;
}
function commentedTextReadingOf(comment, textRedline) {
  var _comment$anchor_text;
  var commentedText = (_comment$anchor_text = comment.anchor_text) !== null && _comment$anchor_text !== void 0 ? _comment$anchor_text : commentedParagraphTextOf(comment, textRedline);
  if (commentedText === null) return {
    kind: "unavailable"
  };
  return {
    kind: "known",
    text: commentedText
  };
}
var CardCommentSubcard = function CardCommentSubcard(_ref3) {
  var cardId = _ref3.cardId,
    conversationId = _ref3.conversationId,
    comment = _ref3.comment,
    textRedline = _ref3.textRedline,
    editAuthor = _ref3.editAuthor,
    cardIsPending = _ref3.cardIsPending;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    editorActionsSlot = _useState4[0],
    setEditorActionsSlot = _useState4[1];
  var _useChat = (0, _ChatContext.useChat)(),
    getActionRecoveryWarning = _useChat.getActionRecoveryWarning;
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    getEdit = _useProposalEdits.getEdit,
    saveEdit = _useProposalEdits.saveEdit;
  var resetProposalEdit = (0, _useResetProposalEdit.useResetProposalEdit)(conversationId);
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  (0, _cardCommentSelections.useCardCommentSelectionsVersion)();
  var cardCommentKey = (0, _cardCommentSelections.cardCommentKeyOf)(cardId, comment);
  var edit = cardCommentKey === null ? undefined : getEdit(conversationId, cardCommentKey);
  var textBeforeEdit = (edit === null || edit === void 0 ? void 0 : edit.kind) === "comment" ? edit.textBeforeEdit : null;
  var isLeftOut = cardCommentKey !== null && !_cardCommentSelections.cardCommentSelections.isChecked(cardCommentKey);
  var canEdit = cardIsPending && cardCommentKey !== null;
  var relocationSentence = cardIsPending || cardCommentKey === null ? undefined : getActionRecoveryWarning(conversationId, cardCommentKey);
  function openEditor() {
    setIsEditing(true);
    analytics === null || analytics === void 0 || analytics.track("proposal_edit_opened", {
      conversationId: conversationId,
      actionId: cardCommentKey,
      cardKind: "comment"
    });
  }
  function saveEditedText(editedText) {
    if (cardCommentKey === null) return;
    saveEdit(conversationId, cardCommentKey, {
      kind: "comment",
      textBeforeEdit: textBeforeEdit !== null && textBeforeEdit !== void 0 ? textBeforeEdit : comment.text,
      text: editedText
    });
    analytics === null || analytics === void 0 || analytics.track("proposal_edit_saved", {
      conversationId: conversationId,
      actionId: cardCommentKey,
      cardKind: "comment"
    });
    setIsEditing(false);
  }
  function renderControls() {
    if (isEditing) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      ref: setEditorActionsSlot,
      className: "flex flex-shrink-0 items-center gap-2"
    });
    if (!canEdit || cardCommentKey === null) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        "aria-label": EDIT_CARD_COMMENT_LABEL,
        title: EDIT_CARD_COMMENT_LABEL,
        onClick: function onClick(event) {
          event.stopPropagation();
          openEditor();
        },
        className: iconButtonClass,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.Pencil, {
          size: 13,
          className: "text-[#686766]",
          "aria-hidden": "true",
          "data-sentry-element": "Pencil",
          "data-sentry-source-file": "CardCommentSubcards.tsx"
        })
      }), textBeforeEdit !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        "aria-label": _ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL,
        title: _ProposalCardActions.RESET_TO_AGENT_VERSION_LABEL,
        onClick: function onClick(event) {
          event.stopPropagation();
          resetProposalEdit(cardCommentKey, "comment", "chat_card");
        },
        className: iconButtonClass,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.Undo2, {
          size: 13,
          className: "text-[#686766]",
          "aria-hidden": "true"
        })
      })]
    });
  }
  function renderText() {
    if (isEditing) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentTextEditor.CommentTextEditor, {
        text: comment.text,
        textBeforeEdit: textBeforeEdit,
        kindLabel: "comment",
        actionsSlot: editorActionsSlot,
        onSave: saveEditedText,
        onCancel: function onCancel() {
          return setIsEditing(false);
        }
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "whitespace-pre-wrap text-[13px] leading-[1.45] text-[#171715]",
      "data-sentry-component": "renderText",
      "data-sentry-source-file": "CardCommentSubcards.tsx",
      children: (0, _CommentTextEditor.commentTextWithUserChanges)(comment.text, textBeforeEdit, editAuthor)
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "card-comment-subcard",
    className: (0, _utils.cn)("flex flex-col gap-0.5 rounded border border-[#E5E2DD] bg-[#FAFAF9] px-2.5 py-1.5 cursor-default", isLeftOut && "opacity-70"),
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    "data-sentry-component": "CardCommentSubcard",
    "data-sentry-source-file": "CardCommentSubcards.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center gap-1.5",
      children: [cardIsPending && cardCommentKey !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(CardCommentCheckbox, {
        isIncluded: !isLeftOut,
        onToggle: function onToggle() {
          return _cardCommentSelections.cardCommentSelections.toggle(cardCommentKey);
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[12px] font-semibold text-[#4a5568]",
        children: _cardKinds.PROPOSAL_CARD_KIND_LABELS.comment
      }), isLeftOut && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-[11px] font-medium text-[#686766]",
        children: CARD_COMMENT_LEFT_OUT_LABEL
      }), relocationSentence && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyRelocatedIndicator.RemedyRelocatedIndicator, {
        relocationSentence: relocationSentence
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "flex-1"
      }), renderControls()]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.ProposalCardContextLine, {
      lead: "On",
      reading: commentedTextReadingOf(comment, textRedline),
      unavailablePhrase: _CommentAnchorContext.UNAVAILABLE_PARAGRAPH_PHRASE,
      "data-sentry-element": "ProposalCardContextLine",
      "data-sentry-source-file": "CardCommentSubcards.tsx"
    }), renderText()]
  });
};
var CardCommentSubcards = exports.CardCommentSubcards = function CardCommentSubcards(_ref4) {
  var comments = _ref4.comments,
    cardOfTheComments = _objectWithoutProperties(_ref4, _excluded);
  var proposalEngineEnabled = (0, _useProposalEngineEnabled.useProposalEngineEnabled)();
  if (!proposalEngineEnabled || comments.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "mt-2 flex flex-col gap-1.5",
    "data-testid": "card-comment-subcards",
    "data-sentry-component": "CardCommentSubcards",
    "data-sentry-source-file": "CardCommentSubcards.tsx",
    children: comments.map(function (comment) {
      var _comment$comment_id;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardCommentSubcard, _objectSpread({
        comment: comment
      }, cardOfTheComments), (_comment$comment_id = comment.comment_id) !== null && _comment$comment_id !== void 0 ? _comment$comment_id : "".concat(comment.bookmark, "|").concat(comment.text));
    })
  });
};